import { CslStyleApi } from '@infrastructure/csl-styles.api'

export class CslStylesService {
  constructor(private cslStyleApi: CslStyleApi) {}
  async find(): Promise<string[]> {
    return this.cslStyleApi.find()
  }
}
